const ITEMS = [
    "• TMZ GUINCHO PLATAFORMA",
    "RODOVIA RÉGIS BITTENCOURT KM 377",
    "• EMBARQUE POR CABO DE AÇO & ASA-DELTA",
    "MIRACATU E REGIÃO",
    "• TRANSPORTE SEGURO E SEM CORRENTE",
    "ORÇAMENTO ACESSÍVEL",
];

export const Marquee = () => (
    <div
        data-testid="marquee-strip"
        aria-hidden="true"
        className="bg-neutral-900 text-white py-3 border-y border-neutral-800 overflow-hidden font-bold text-xs uppercase tracking-widest"
    >
        <div className="mq-track gap-8 items-center text-neutral-300">
            {[...ITEMS, ...ITEMS].map((text, i) => (
                <span key={i} className={text.startsWith("•") ? "text-[#ff6200]" : ""}>
                    {text}
                </span>
            ))}
        </div>
    </div>
);
